import { Link } from 'react-router'
import { Award, ArrowRight, CheckCircle } from 'lucide-react'

/**
 * Cross-link banner pushing users to /rge/{service}/{city}.
 * Targets the "RGE seeker" persona — high commercial intent, low competition
 * (~480/mo "plombier RGE Nice"). Most marketplaces don't surface RGE filtering.
 *
 * Service slug must be in RGE_SERVICES (defined in lib/sitemap.ts).
 * For non-RGE-eligible services (e.g. déménagement), component returns null.
 */
const RGE_ELIGIBLE = new Set([
  'plomberie',
  'electricite',
  'chauffage',
  'climatisation',
  'isolation',
  'toiture',
  'menuiserie',
  'panneaux-solaires',
  'renovation',
  'peinture',
])

export function RgeCrossLink({
  serviceSlug,
  cityName,
  citySlug,
  serviceName,
}: {
  serviceSlug: string
  cityName: string
  citySlug: string
  serviceName: string
}) {
  if (!RGE_ELIGIBLE.has(serviceSlug)) return null

  return (
    <aside className="mt-8 overflow-hidden rounded-2xl border-2 border-emerald-200 bg-gradient-to-br from-emerald-50 to-green-50 p-5">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-emerald-500 text-white shadow-sm">
          <Award className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-bold text-emerald-900">
            Recherchez un {serviceName.toLowerCase()} certifié RGE à {cityName} ?
          </h3>
          <p className="mt-1 text-sm text-emerald-800">
            La qualification RGE (Reconnu Garant de l'Environnement) est obligatoire
            pour bénéficier de MaPrimeRénov', CEE et éco-PTZ. Économies jusqu'à
            <strong> 20 000 €</strong>.
          </p>

          <ul className="mt-3 space-y-1 text-xs text-emerald-700">
            <li className="flex items-center gap-1.5">
              <CheckCircle className="h-3 w-3 shrink-0" />
              Certifications Qualibat / Qualifelec / Qualit'EnR vérifiées
            </li>
            <li className="flex items-center gap-1.5">
              <CheckCircle className="h-3 w-3 shrink-0" />
              Cumulable avec primes énergie (CEE)
            </li>
            <li className="flex items-center gap-1.5">
              <CheckCircle className="h-3 w-3 shrink-0" />
              TVA réduite à 5,5 % sur travaux énergétiques
            </li>
          </ul>

          <Link
            to={`/rge/${serviceSlug}/${citySlug}`}
            className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700"
          >
            Voir les artisans RGE à {cityName}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </aside>
  )
}
